import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { EnglishTranslation, MalayTranslation, ExternalLinks, ProductCode } from '../app.constants';

@Component({
  selector: 'app-thank-you-director',
  templateUrl: './thank-you-director.component.html',
  styleUrls: ['./thank-you-director.component.scss']
})
export class ThankYouDirectorComponent implements OnInit {
  product:string
  CustomerCareEmail: any
  ReferenceNumber: any
  isSecondDirector: boolean = false
  SecondDirectorName: any
  hyperLink: any
  isMobile: boolean = false;
  textContent: any;
  ekycLink: string;
  
  constructor(private router: Router, public connectRestService: ConnectRestService) { }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language") ? sessionStorage.getItem("language"): "en-us";
    var product = sessionStorage.getItem("currentProduct");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.EndLastStepScreen : MalayTranslation.EndLastStepScreen;

    if (product == ProductCode.eBizi) {
      this.ekycLink = ExternalLinks.EkycFaq.eBizi[langTranslation];
      this.textContent.number = "603 8314 9090";
    } else {
      this.ekycLink = ExternalLinks.EkycFaq.eBiz[langTranslation];
    }
    var platform = this.connectRestService.getPlatformInformation();
    var arrayPlatform = platform.split(' ');
    var data = JSON.parse(sessionStorage.FinalResponse);
    this.CustomerCareEmail = data.CustomerCareEmail;
    this.ReferenceNumber = data.ReferenceNumber;
    
    
    if (sessionStorage.directorDetails) {
      var directorDetails = JSON.parse(sessionStorage.directorDetails);
      if(directorDetails && directorDetails.length>1){
        this.SecondDirectorName = directorDetails[1].Name;
        this.isSecondDirector = true;
      }
    }

    this.isMobile = arrayPlatform[0] && (arrayPlatform[0].toLowerCase() === "ios" || arrayPlatform[0] === 'Android');

    var locStorage=JSON.parse(localStorage.getItem("URLParam"));
    this.product=locStorage.ProductDescription;
   
  }

  redirect() {
    this.router.navigate(['/redirecting']);
  }
}
